import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CalendarModule } from 'primeng/calendar'
import { SelectButtonModule } from 'primeng/selectbutton'
import { ActionBarComponent } from './action-bar.component'
import { MenuModule } from 'primeng/menu'
import { BadgeModule } from 'primeng/badge'
import { OverlayPanelModule } from 'primeng/overlaypanel'
import { SearchboxModule } from '@stantec/basin/searchbox'
import { CircledIconModule } from '@stantec/basin/circled-icon'
import { UserAvatarGroupModule } from '@stantec/basin/user-avatar-group'
import { AvatarModule } from 'primeng/avatar'
import { AvatarGroupModule } from 'primeng/avatargroup'

@NgModule({
  declarations: [ActionBarComponent],
  imports: [
    CommonModule,
    CalendarModule,
    MenuModule,
    BadgeModule,
    OverlayPanelModule,
    SelectButtonModule,
    SearchboxModule,
    CircledIconModule,
    AvatarModule,
    AvatarGroupModule,
    UserAvatarGroupModule,
  ],
  exports: [ActionBarComponent],
})
export class ActionBarModule {}
